export default {
    user:{
        account:"Account",
        name:"Display Name",
        btn_reset_pwd:"Reset Password",
        btn_sync_contact:"Sync Contacts",
        btn_sync_user:"Sync Users",
        status:"Status",
        type:"Role Type",
        add_user:"Add Account",
        add_role:"Add Role",
        account_info:"Account Information",
        // role_info:"Role Information",
        role_name:"Role Name",
        belonging:"Customer",
        proxy_customer:"Agent Customer",
        edit_account:"Edit Account",
        gender:"Gender",
        user:"User Count",
        role:"Role",
        resource:"Interactive Resources",
        governing_customers:"Managed Company",
        associated_architecture:"Accessible Organizations",
        tip_before_delete:"Deleting this customer will also delete its associated scopes, devices, users, and other resources. Confirm deletion?",
        //账户类型
        type_customer_normal:"Company User",
        type_customer_admin:"Company Admin",
        type_platform_normal:"Platform User",
        type_platform_admin:"Platform Admin",
        type_customer_proxy:"Agent Admin",
        synchronizing:"Synchronizing in progress, please do not close the page...",
        code_200:"Reset Successful",
        code_0:"Sync Failed",
        code_1:"Sync Successful",
        code_2:"Duplicate records found, skipped.",
        code_404:"User information not found",
        code_other:"Unknown Error",
        gender_1:"Male",
        gender_0:"Female",
        remarks:"Remark",
        view_associated_user:"View Icon of User",
        role_edit:"Edit Role",
        role_info:"Role Infomation",


        tip_del_default_role:"The default role cannot be deleted.",
        tip_del_default_role_multi:"The selected data is associated with a default role and cannot be deleted.",
        tip_del_role:"Deleting the role will delete the associated users. Continue?",
        tip_least_reain_one_data:"At least one record is required.",

        //编辑用户返回的状态码
        user_edit_code_200:"Edit successful",
        user_new_code_200:"Successfully added",
        user_new_code_201:"Added successfully, but sync contacts failed.",
        user_edit_code_201:"Edit successful, but sync contacts failed.",
        user_edit_code_412:"Invalid email address format.",
        user_new_code_414:"Status is required.",
        user_edit_code_416:"Account already exists.",
        user_edit_code_417:"User name already exists.",
        user_edit_code_418:"Mobile number already exists.",
        user_edit_code_419:"Email already exists.",
        user_edit_code_501:"Failed to edit user because the account is deactivated.",
        user_new_code_501:"Failed to add user because the account is deactivated.",


        //编辑角色返回的状态码
        role_edit_code_405:"Role name is required",
        role_edit_code_406:"Role name cannot exceed 50 characters",
        role_edit_code_407:"Customer is required",
        role_edit_code_408:"The customer must be the same as the current user's associated customer.",
        role_edit_code_409:"The role name olready exists.",
        role_edit_code_410:"Role type is required",
        role_edit_code_411:"Role status is required",
        role_edit_code_412:"Remark cannot exceed 250 characters",
        role_edit_code_413:"Resource is required",
        role_edit_code_415:"Select at least one agent",
        role_edit_code_500:"Save failed, please try again",


        popover_icon:"The meaning of the icon is as follows,",
        popover_role_type:"Role Type Icon",
        popover_account_type:"Account Type Icon",
        popover_status:"Status Icon",
        popover_account_default:"Account Default Icon",
    }
}
